import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchVehicleDealerships,
  initializeVehicleDealershipsScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleDealerships,
  deleteVehicleDealerships,
  saveVehicleDealershipsTableState,
} from "../../../redux/actions/vehicles/vehicleDealerships";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import VehicleDealerships from '../../../component/Vehicles/VehicleDealerships';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleDealershipsScreen(props) {
  const {
    fetchVehicleDealerships,
    initVehicleDealershipsScreen,
    showPageLevelLoader,
    vehicleDealershipsListview,
    paginationInfo,
    screenPermissions,
    exportVehicleDealerships,
    isVehicleDealershipsExportError,
    isVehicleDealershipsExportSuccess,
    isLoading,
    deleteVehicleDealerships,
    isVehicleDealershipsDeleteSuccess,
    isVehicleDealershipsDeleteError,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    savedTableState,
    saveVehicleDealershipsTableState,
  } = props;
  const navigate = useNavigate();
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    const isISODateString = (str) => typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    const formatFilterValue = (value) => {
      if (value instanceof Date) return formatDate(value, DATE_STRATEGY.DATE_ISO);
      if (isISODateString(value)) return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      return value;
    };
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(state.filters[key].value),
          });
        }
      });
    }
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
    };
  };

  useEffect(() => {
    initVehicleDealershipsScreen();
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    if (savedParams) {
      fetchVehicleDealerships(savedParams);
    } else {
      fetchVehicleDealerships({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableStateChange = (tableState) => {
    saveVehicleDealershipsTableState(tableState);
  };

  const loadLazyData = (props) => {
    fetchVehicleDealerships(props);
  };
  const handleCreateVehicleDealerships = () => {
    navigate(APP_URLS.VEHICLE_DEALERSHIPS.CREATE);
  }
  const editVehicleDealershipsRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_DEALERSHIPS.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleDealerships = {
    handleCreateVehicleDealerships,
    exportVehicleDealerships,
    isVehicleDealershipsExportError,
    isVehicleDealershipsExportSuccess,
    editVehicleDealershipsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteVehicleDealerships,
    isVehicleDealershipsDeleteSuccess,
    isVehicleDealershipsDeleteError,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    fetchVehicleDealershipss: loadLazyData,
    tableData: {
      columns: vehicleDealershipsListview?.columns,
      rows: vehicleDealershipsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleDealerships
        {...vehicleDealerships}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleDealershipsScreen: () => dispatch(initializeVehicleDealershipsScreen()),
    fetchVehicleDealerships: (payload) => dispatch(fetchVehicleDealerships(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleDealerships: (payload) => dispatch(exportVehicleDealerships(payload)),
    deleteVehicleDealerships: (payload) => dispatch(deleteVehicleDealerships(payload)),
    saveVehicleDealershipsTableState: (payload) => dispatch(saveVehicleDealershipsTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleDealershipsCreateSuccess: selectFromVehicleDealershipsReducer(
      state,
      "isVehicleDealershipsCreateSuccess"
    ),
    vehicleDealershipsListview: selectFromVehicleDealershipsReducer(
      state,
      "vehicleDealershipsListview"
    ),
    showPageLevelLoader: selectFromVehicleDealershipsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleDealershipsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleDealershipsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleDealershipsReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleDealershipsExportError: selectFromVehicleDealershipsReducer(
      state,
      "isVehicleDealershipsExportError"
    ),
    isVehicleDealershipsExportSuccess: selectFromVehicleDealershipsReducer(
      state,
      "isVehicleDealershipsExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromVehicleDealershipsReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isVehicleDealershipsDeleteSuccess: selectFromVehicleDealershipsReducer(
      state,
      "isVehicleDealershipsDeleteSuccess"
    ),
    isVehicleDealershipsDeleteError: selectFromVehicleDealershipsReducer(
      state,
      "isVehicleDealershipsDeleteError"
    ),
    savedTableState: selectFromVehicleDealershipsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleDealershipsReducer = (state, path) => {
  return selectVehicleDealershipsReducer(state)[path];
};

const selectVehicleDealershipsReducer = ({ vehicleDealershipsReducer }) => {
  return vehicleDealershipsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleDealershipsScreen);
